import * as React from "react"
import { AlertProps, Alert as MuiAlert, Snackbar } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDoubleDown, faChevronDoubleUp } from "@fortawesome/pro-solid-svg-icons";
import { useScopedField } from "@ngt/forms-core";
import { CommWebResponseCode, Payment } from "@/api/dtos";
import getCreditCardErrorMessage from "@/utils/getCreditCardErrorMessage";

interface FormErrorProps {
    error?: any;
    hasError?: boolean;
    handleClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
    index: number;
}

const FormError: React.FunctionComponent<FormErrorProps> = ({ error, hasError, handleClose, index }) => {
    const {state: {value: response}} = useScopedField<CommWebResponseCode>("payments["+index+"].paymentStatus", {value: true});
    const {state: {value: payments}} = useScopedField<Payment[]>("payments", {value: true});
    const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
        props,
        ref,
      ) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    return (
        <Snackbar 
            open={hasError} 
            autoHideDuration={5000} 
            onClose={handleClose} 
            anchorOrigin={{vertical:'bottom', horizontal:'right'}}
        >
            <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                {error ? error.responseStatus.message : "An error occured while trying to save the form"}
            </Alert>
        </Snackbar>
    )
}

export default FormError;